import { format } from "date-fns";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import styles from "./ViewStatement.module.scss";
import Table from "../../../../common/Table/Table";
import NoContent from "../../../../common/NoContent/NoContent";
import Commonpagination from "../../../../common/Pagination/Commonpagination";
import { cardDetailsAction, viewStatementAction } from "../../../../../features/user/userSlice";

const ViewStatement = () => {
  const dispatch = useDispatch()
  const [page, setPage] = useState(1);
  const cardType = localStorage.getItem("cardType");
  const [cardDetails, setCardDetails] = useState({});
  const [TransactionData, setTransactionData] = useState({});

  const cardId = cardType === "CREDIT" ? cardDetails?.credit?.rain_card_id : cardDetails?.debit?.rain_card_id;

  const viewStatement = async () => {
    if (!cardId) return;
    try {
      const data = {
        page: page,
        limit: 10,
        type: "month",
      }
      const res = await dispatch(viewStatementAction(cardId, data));
      if (res.status === 200) {
        const fullList = res?.data?.data || [];
        setTransactionData(fullList);
      }
    } catch (error) {
      console.log("Error");
    }
  };

  // ********** GET CARD DETAILS **********
  const getCardDetails = async () => {
    try {
      const res = await dispatch(cardDetailsAction());
      if (res?.status === 200) {
        const cards = res?.data?.data || [];
        const debit = cards.find((c) => c.card_type === "DEBIT");
        const credit = cards.find((c) => c.card_type === "CREDIT");
        setCardDetails({ debit: debit, credit: credit })
      } else {
        setCardDetails({});
      }
    } catch (error) {
      console.log(error, "error");
    }
  }

  useEffect(() => {
    getCardDetails()
  }, [])

  useEffect(() => {
    if (cardId) {
      viewStatement()
    }
  }, [cardId, page])


  const fields = [
    { label: "Amount", value: "amount" },
    { label: "Status", value: "status" },
    { label: "Created At", value: "created_at" },
  ];

  return (
    <>
      <div className={styles.recent_transactions_head}>
        <h2>
          View Statement
        </h2>
      </div>
      <Table
        fields={fields}
        className='table'
        loadingClassName={"loading_table"}
      >
        {TransactionData?.list?.length > 0 ?
          TransactionData?.list?.map((item, index) => (
            <tr key={index}>
              <td>{item?.amount}</td>
              <td>{item?.transaction_status}</td>
              <td>{format(new Date(item?.created_at), "dd MMM, yyyy")}</td>
            </tr>
          )) :
          <tr>
            <td colSpan={fields.length}>
              <NoContent
                className={styles.no_record}
              />
            </td>
          </tr>
        }
      </Table>
      {TransactionData?.totalItems > 10 && (
        <Commonpagination
          pagination
          currentPage={TransactionData?.currentPage}
          className={styles.pagination}
          pageSize={10}
          totalPages={TransactionData?.totalPages}
          handlePageChange={(selected) => setPage(selected)}
        />
      )}
    </>
  );
};

export default ViewStatement;
